import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ReactSelect from 'react-select'

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;

  * {
    font-size: 14px;
    font-family: 'Open Sans';
    font-weight: 400;
    color: #222;
  }

  input[type='date'],
  input[type='time'] {
    -webkit-appearance: none;
  }
`

export const Label = styled.label`
  position: absolute;
  top: -12px;
  left: 14px;
  margin: 0px;
  background: linear-gradient(0deg, rgba(255,255,255,0) 50%, rgba(255,255,255,1) 50%);
  padding: 4px;
  z-index: 1;
`

export const NativeSelect = styled.select`
  width: 100%;
  height: 56px; // Ajustar altura do select do histórico
  border: 1px solid #999999;
  border-radius: 8px;
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  color: #555555;
  padding-left: 15px;
  font-size: 16px;
  font-weight: 400;
  background-color: #fff;
  appearance: none;
  -webkit-appearance: none;

  &[disabled] {
    background-color: var(--alto-gray);
    cursor: not-allowed;
  }

  &:focus {
    outline: unset;
  }
`

export const SelectArrow = styled.div`
  position: absolute;
  right: 20px;
  top: 25%;
  cursor: pointer;
  pointer-events: none;

  &[disabled] {
    opacity: .5;
  }
`

export const ErrorMessage = styled.p`
  color: #ff0000;
  font-size: 13px;
  font-family: 'Open Sans';
  font-weight: 400;
  margin: 0px;
`

export const renderSelectStyles = (override) => {
  return {
    placeholder: (provided) => {
      return {
        ...provided,
        marginLeft: 0,
        marginRight: 0
      }
    },
    option: (provided, { isFocused }) => {
      return {
        ...provided,
        backgroundColor: isFocused ? '#D8EEF6' : null,
        color: '#555555',
        zIndex: 2
      }
    },
    control: (provided) => ({
      ...provided,
      width: '100%',
      height: override?.height || '40px',
      border: '1px solid #999999',
      borderRadius: '8px',
      backgroundColor: '#fff',
      boxShadow: 'none',
      fontFamily: 'Open Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: 'normal',
      '&:hover': {
        borderColor: '#999999'
      }
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    dropdownIndicator: base => ({
      ...base,
      svg: {
        fill: '#777777',
        width: '16px',
        height: '16px'
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      marginTop: 0,
      borderRadius: '0 0 8px 8px'
    })
  }
}

const Select = ({
  options = [],
  name,
  label = 'Escolha uma opção',
  onChange,
  selectedValue: initialValue,
  emptyLabel = 'Selecione uma opção',
  id = '',
  disabled = false,
  errorMessage,
  hookForm,
  hasTextInput = false,
  overrideStyles,
  arrowColor = '#01878E',
  arrowSize = '22'
}) => {
  const [selectedValue, setSelectedValue] = useState('')
  const hasError = !!errorMessage

  useEffect(() => {
    if (initialValue) {
      setSelectedValue(initialValue)
    }
  }, [initialValue])

  const handleSelectOption = selectedOption => {
    const value = selectedOption.value
    if (hookForm) {
      const syntheticEvent = { target: { name, value } }
      hookForm.onChange(syntheticEvent)
    }
    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <Container>
      {label && <Label>{label}</Label>}
      <ReactSelect
        {...hookForm}
        name={name}
        id={id}
        value={options.find((option) => option.value === selectedValue)}
        onChange={(option) => { handleSelectOption(option) }}
        isDisabled={disabled}
        placeholder={emptyLabel}
        options={options}
        styles={{ ...renderSelectStyles(overrideStyles) }}
        isSearchable={hasTextInput}
      />
      {hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  )
}

export default Select
